import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LoadDowntimeMessageFail,
  LoadDowntimeMessageSuccess,
  LoadDowntimeMessage,
} from './downtime.actions';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DowntimeFacade } from '../../../services/account/downtime/downtime.facade';

export const getDowntimeMessage = createEffect(
  (actions$ = inject(Actions), downtimeFacade = inject(DowntimeFacade)) => {
    return actions$.pipe(
      ofType(LoadDowntimeMessage),
      switchMap(() =>
        downtimeFacade.getDowntimeMessage().pipe(
          map(({ downtimeMessage }) => LoadDowntimeMessageSuccess({ downtimeMessage })),
          catchError((error: Error) => of(LoadDowntimeMessageFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
